import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { features } from '../data/landing';
export function BenefitsSection() {
  return <section id="incluye" className="bg-white py-16 sm:py-24" data-id="element-1" data-mp="3iq83a84yn6ef">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-2" data-mp="3ipy9sakpih3z">
        <SectionHeading title="Todo lo que incluye tu Cotizador PRO" data-id="element-3" data-mp="3nohw4c37puwv" />
        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6" data-id="element-4" data-mp="38s0krkv0wgab">
          {features.map((feature, i) => <Reveal as="li" key={feature.title} delay={i % 3 * 0.05} className="h-full" data-id="element-5" data-mp="3drdjb2v9bbsq" data-mpi={i}>
              <div className="flex h-full gap-4 rounded-2xl border border-slate-200 bg-white p-5 sm:flex-col sm:p-6" data-id="element-6" data-mp="2zrvp27z6z6bz">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-primary-light text-2xl" aria-hidden="true" data-id="element-7" data-mp="34rgp6lq3lkqa">
                  {feature.emoji}
                </span>
                <div data-id="element-8" data-mp="12zc33qva5hnh">
                  <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-9" data-mp="12xr3hmu3z8ir">{feature.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-slate-600" data-id="element-10" data-mp="2bdut2vqd4mda">{feature.description}</p>
                </div>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}